/**
 **@disc: 设备信息变更工单常量
 **@author: mengln
 */
export const DeviceInfoEditConstant = {
  TICKET: 'DeviceInfoEdit'
};

/**
 * 设备操作 现场支持 系统操作类工单templateCode
 */
export const ServiceSupport = [
  'DeviceView',
  'NetworkMaint',
  'PeripheralAccess',
  'IPConfig',
  'OtherService',
  'RemoteConnection',
  'DeviceShutDown',
  'DeviceBoot',
  'ResetBMC',
  'SystemReinstall',
  'DeviceReboot',
  'DeviceNetoff',
  'DevicePoweroff',
  'CabinetView',
  'ReplacementChange',
  'VerifyWiringDistance'
];

/**
 **@disc: ServiceCodeConstant
 */
export const ServiceCodeConstant = {
  'CCS': 'epcs'
};


/**
 **@disc: regionConstant
 */
export const RegionConstant = {
  'stag': 'cn-north-1',
  'other': 'cn-north-1',
};




// WEBPACK FOOTER //
// ./src/common/Constants.js